import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitSpecificationsPage } from '@/loaders/unit.specifications.loader';
import { UnitsSpecificationsPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/specifications/')({
  component: UnitsSpecificationsPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitSpecificationsPage,
});
